import React from "react";
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";

// https://github.com/xiaolin/react-image-gallery

class Gallery extends React.Component {

  render() {

    const images = [
      {
        original: 'images/gallery_09.jpg',
        description: 'Minister for Education Mr Ong Ye Kung, Professor Bo An, Professor Dai Bing Tian, Professor Ng See Kiong, Dr Pan Yaozhang, Lim Teck Yong and Assistant Chief Executive, Planning, IMDA, Koh Li-Na on stage as they launch the National Data Science Challenge 2019.',
        thumbnail: 'images/gallery_09.jpg'
      },
      {
        original: 'images/gallery_10.jpg',
        description: 'Minister for Education, Mr Ong Ye Kung as he gives his remarks at the National Data Science Challenge 2019.',
        thumbnail: 'images/gallery_10.jpg'
      },
      {
        original: 'images/gallery_11.jpg',
        description: 'Judges of the competition Professor Ng See Kiong, Dr Pan Yaozhang, Professor Bo An and Professor Dai Bing Tian, as they participate in a panel discussion on the Revolution of Data Science, moderated by Regional Master Trainer, Learning & Development, Joel Seah.',
        thumbnail: 'images/gallery_11.jpg'
      },
      {
        original: 'images/gallery_12.jpg',
        description: 'The National Data Science Challenge is strongly supported by 59 partners including government agencies, local education institutions and tech communities.',
        thumbnail: 'images/gallery_12.jpg'
      },
      {
        original: 'images/gallery_07.jpg',
        description: 'Over 1,700 participants attended the National Data Science Challenge Opening Ceremony on 23 February 2019 at Singapore Expo, MAX Atria.',
        thumbnail: 'images/gallery_07.jpg'
      },
      {
        original: 'images/gallery_06.jpg',
        description: 'Participants registering for the National Data Science Challenge Opening Ceremony on 23 February 2019 at Singapore Expo, MAX Atria',
        thumbnail: 'images/gallery_06.jpg'
      },
      {
        original: 'images/gallery_08.jpg',
        description: 'Participants interacting with our Partners at the networking booths during the opening ceremony.',
        thumbnail: 'images/gallery_08.jpg'
      },
      {
        original: 'images/gallery_13.png',
        description: 'At the NDSC 2019 Award Ceremony on 30 March, we awarded the Top 3 teams, the Most Creative teams and Merit teams from the Beginner and Advanced categories. We also recognised outstanding individuals who contributed actively to the Kaggle discussion board.',
        thumbnail: 'images/gallery_13.png'
      },
      {
        original: 'images/gallery_14.png',
        description: 'The Champion team (Beginner Category), asdf, achieved the best score by having the most comprehensive and up-to-date models such as BERT, CNN, Attention, Multi-branching, GBM, etc.',
        thumbnail: 'images/gallery_14.png'
      },
      {
        original: 'images/gallery_15.png',
        description: 'The Most Creative Team (Beginner Category), aigeniuses, wowed the judges with their creative approach to the challenge!',
        thumbnail: 'images/gallery_15.png'
      },
      {
        original: 'images/gallery_16.png',
        description: 'The Champion Team (Advanced Category), yellow, achieved the highest ranking on Kaggle due to the wise usage of data and models such as NN and NB-SVM.',
        thumbnail: 'images/gallery_16.png'
      },
      {
        original: 'images/gallery_17.png',
        description: 'The Most Creative Team (Advanced Category), ShopeeSense, was not only creative in the approach of the challenge, but was also creative in the articulation and presentation of their approach!',
        thumbnail: 'images/gallery_17.png'
      },
      {
        original: 'images/gallery_18.png',
        description: 'The top teams of the Beginner Category were presented the awards by Professor Ng See Kiong who was part of the esteemed judging panel.',
        thumbnail: 'images/gallery_18.png'
      },
      {
        original: 'images/gallery_19.png',
        description: 'The top teams of the Advanced Category were presented the awards by Professor Dai Bing Tian who was part of the esteemed judging panel.  ',
        thumbnail: 'images/gallery_19.png'
      },
      {
        original: 'images/gallery_20.png',
        description: 'Mr Lim Teck Yong, Head of People and Regional Operations in Shopee, gave an opening address to all the participants during the NDSC Award Ceremony on 30 March.',
        thumbnail: 'images/gallery_20.png'
      },
      {
        original: 'images/gallery_21.png',
        description: 'Dr Pan Yaozhang, Head of Data Science at Shopee, shared about the common techniques used by the participants, as well as the models used by the top teams during the NDSC Award Ceremony on 30 March.',
        thumbnail: 'images/gallery_21.png'
      },
      {
        original: 'images/gallery_22.png',
        description: 'Participants at the NDSC 2019 Award Ceremony listening attentively to the presentation by the Champion Team and Most Creative Team from the respective competition categories.',
        thumbnail: 'images/gallery_22.png'
      },
      {
        original: 'images/gallery_01.jpg',
        description: 'Advanced Training Workshop on Tensorflow held on 16 December 2018. Participants learnt about the elements of Tensorflow and the visualization of the computational graph.',
        thumbnail: 'images/gallery_01.jpg'
      },
      {
        original: 'images/gallery_02.jpg',
        description: 'Beginner Training Workshop on Essential Machine Learning held on 15 December 2018. Participants learnt about Python, data science and machine learning.',
        thumbnail: 'images/gallery_02.jpg'
      },
      {
        original: 'images/gallery_03.jpg',
        description: 'A Shopee representative sharing the competition details to the participants who attended the second run of the NDSC x Yidu AI Advanced Training Workshop on 26 January 2019 at INSEAD Auditorium',
        thumbnail: 'images/gallery_03.jpg'
      },
      {
        original: 'images/gallery_04.jpg',
        description: 'Participants attended the second run of the NDSC x YiDu AI Beginner Workshop on 2 February 2019 at PSB Academy.',
        thumbnail: 'images/gallery_04.jpg'
      },
      {
        original: 'images/gallery_05.jpg',
        description: 'Individual participants attended the NDSC Networking Session on 8 February 2019 at Shopee HQ',
        thumbnail: 'images/gallery_05.jpg'
      },

    ]

    return (
      <section id="gallery">
        <div className="container d-flex justify-content-center">
          <div className="col-md-12">
            <div className="title-block">
              <h2>Photo Gallery</h2>
            </div>
            <ImageGallery items={images} showFullscreenButton={false} showPlayButton={false} autoPlay={true} slideInterval={6000} />
          </div>
        </div>
      </section>
    );
  }

}

export default Gallery;